// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29XxT","col":"styles_col__3YAHa","actions":"styles_actions__2nlYf","conflict":"styles_conflict__10ay0"};